import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

export const commissionsAdjustResolver = yupResolver(
  yup.object().shape({
    percentage: yup
      .number()
      .transform((_, originalValue) => (originalValue === '' ? undefined : Number(originalValue)))
      .min(0, 'Percentage must be at least 0%')
      .max(100, 'Percentage must be at most 100%'),
    amount: yup
      .number()
      .transform((_, originalValue) => (originalValue === '' ? undefined : Number(originalValue)))
      .min(0, 'Amount must be at least 0'),
  }),
)
